import { combineReducers, Reducer } from 'redux';
import { SharedBillingState } from '../web-shared/redux/defaults/shared-billing';
import notices from '../web-shared/redux/reducers/notices';
import sharedBilling from '../web-shared/redux/reducers/shared-billing';
import { AuthState } from './defaults/auth';
import { AuthConfigState } from './defaults/authConfig';
import { AuthProgressState } from './defaults/authProgress';
import { BillingState } from './defaults/billing';
import { ConfigState } from './defaults/config';
import { DeviceState } from './defaults/device';
import { DeviceAuthState } from './defaults/device-auth';
import { LandingPageState } from './defaults/landing-page';
import { LaunchState } from './defaults/launch';
import auth from './reducers/auth';
import authConfig from './reducers/authConfig';
import authProgress from './reducers/authProgress';
import billing from './reducers/billing';
import config from './reducers/config';
import device from './reducers/device';
import deviceAuth from './reducers/device-auth';
import landingPage from './reducers/landing-page';
import launch from './reducers/launch';

// JD: The whitelist for redux-persist uses these key names.
export const BILLING_REDUCER_KEY_NAME = 'billing';
export const AUTH_PROGRESS_REDUCER_KEY_NAME = 'authProgress';
export const API_CONFIG_REDUCER_KEY_NAME = 'authConfig';
export const DEVICE_REDUCER_KEY_NAME = 'device';
export const CONFIG_REDUCER_KEY_NAME = 'config';

export default function create(reducers?: Record<string, Reducer>) {
  return combineReducers({
    auth,
    config,
    billing,
    notices,
    landingPage,
    launch,
    sharedBilling,
    deviceAuth,
    [API_CONFIG_REDUCER_KEY_NAME]: authConfig,
    [AUTH_PROGRESS_REDUCER_KEY_NAME]: authProgress,
    [DEVICE_REDUCER_KEY_NAME]: device,
    ...reducers,
  });
}

export interface RootState {
  analytics: any;
  auth: AuthState;
  authConfig: AuthConfigState;
  authProgress: AuthProgressState;
  billing: BillingState;
  config: ConfigState;
  device: DeviceState;
  deviceAuth: DeviceAuthState;
  landingPage: LandingPageState;
  launch: LaunchState;
  notices: any;
  sharedBilling: SharedBillingState;
}
